interface CostInfoProps {
  estimatedCost: string | undefined;
  buyingPower: string | undefined;
  buyingPowerLabel?: string;
}

export const CostInfo = ({
  estimatedCost,
  buyingPower,
  buyingPowerLabel = "Buying Power",
}: CostInfoProps) => (
  <div className="flex flex-col gap-1">
    <div className="flex items-center justify-between">
      <p className="m-0 p-0 font-medium text-gray-800 text-sm">
        Estimated Cost
      </p>
      <p className="m-0 p-0 font-medium font-mono text-gray-800 text-sm">
        {estimatedCost}
      </p>
    </div>
    <div className="flex items-center justify-between">
      <p className="m-0 p-0 text-gray-700 text-xs">{buyingPowerLabel}</p>
      <p className="m-0 p-0 font-medium font-mono text-gray-800 text-xs">
        {buyingPower}
      </p>
    </div>
  </div>
);
